import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { modal } from 'helpers/decorators'
import { MaterialModal } from 'components/layout'
import { Title } from 'components/misc'
import MODALS from 'constants/layout/modals'
import ResetPassword from '../../forms/dashboard/ChangePassword/ChangePassword'
import { get } from 'lodash'

@modal.trigger()
class ChangePassword extends Component {
  static propTypes = {
    modalObj: PropTypes.shape({
      modal: PropTypes.object,
      id: PropTypes.number,
      userType: PropTypes.string
    })
  }

  render() {
    const { modalData } = this.props

    return (
      <MaterialModal.Body id={MODALS.CHANGE_OLD_PASSWORD} noHeader>
        <MaterialModal.Content minimal>
          <Title h2 intlKey="label.we_need_to_change_your_password">
            We need to change your password
          </Title>
          <div>
          <ResetPassword
            id={get(modalData, 'id')}
            userType={get(modalData, 'userType')}
            orgId={get(modalData, 'orgId')}
          />
          </div>
        </MaterialModal.Content>
      </MaterialModal.Body>
    )
  }
}

export default ChangePassword
